module.exports = __webpack_public_path__ + "img/icon_map_2_on_011.965a8a8c.png";